const P = 'tg.';
export function load<T>(key: string, fallback: T): T {
  try { const s = localStorage.getItem(P + key); return s == null ? fallback : (JSON.parse(s) as T); } catch { return fallback; }
}
export function save(key: string, v: unknown) { try { localStorage.setItem(P + key, JSON.stringify(v)); } catch { /* quota / private mode */ } }
export function remove(key: string) { try { localStorage.removeItem(P + key); } catch { /* */ } }
